import reducer from "./reducer";
export { default as AssetsDiscountsEntryPerConcept } from "./components/index";
export { default as assetsDiscountsEntryPerConceptReducerName } from "./constants";
export default reducer;
